import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { DispatchProp, connect } from "react-redux";
import Icon, { ICON_KIND } from "../components/Icon";
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarNavDropdown,
  CSidebarNavItem,
  CImg,
  CNavLink,
} from "@coreui/react";
import { cilBullhorn } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import { State } from "../store";
// sidebar nav config
import { getNavigation } from "../routes";
import {
  setLeadPaginator,
  setLeadSearchCriteria,
  setUsersPaginator,
} from "../state/actions";
import { defaultLeadSearchCriteria } from "../types/lead";
import { defaulSortedtPaginator, defaultPaginator } from "../types/pagination";
import Skeleton from "react-loading-skeleton";
import useToggle from "../hooks/toggle";
import { contactlist } from "../views/leads/components/AddEditContact";
import { AgentMeta } from "../types";
import TransactionSidebar from "./TransactionSidebar";

export interface selectedcoagent {
  id: string;
  name: string;
}

export interface externalagentmeta {
  id: string;
  firstName: string;
  lastName: string;
  role: string;
  email: string;
  phone: string;
}

export interface client {
  address1: string | null;
  address2: string | null;
  city: string | null;
  country: string | null;
  dateOfBirth: string | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  leadId: string | null;
  phone: string | null;
  relationshipStatus: string | null;
  state: string | null;
  tShirtSize: string | null;
  zip: string | null;
}

export interface NewOffer {
  propertytype: string;
  state: string;
  propertyaddress: string;
  listing_id: string;
  offercode: string;
  clienttype: string;
  clientid: string;
  clientname: string;
  buyertype: string;
  agent: selectedcoagent;
  coagent: selectedcoagent;
  externalagent: selectedcoagent;
}

export interface NewOffervalidation {
  propertytype: string;
  state: string;
  propertyaddress: string;
  listing_id: string;
  offercode: string;
  clienttype: string;
  clientid: string;
  clientname: string;
  buyertype: string;
  agent: string;
  coagent: string;
  externalagent: string;
}

export interface showsuggestions {
  contact: boolean;
  agent: boolean;
  coagent: boolean;
  address: boolean;
  externalagent: boolean;
}

export interface filteredadress {
  unparsedAddress: string;
}

export interface roleslist {
  agents: AgentMeta[];
  coagents: [];
  externalagents: externalagentmeta[];
}

type Props = {
  user: State["auth"]["user"];
  leads: State["leads"]["lead"];
  showSidebar: boolean;
  toggleSidebarMobile: (x: boolean) => void;
} & DispatchProp<any>;

const TheSidebar: React.FC<Props> = (props) => {
  const [loading, setLoading] = useState(true);
  const [modalshow, toggle] = useToggle(false);
  const [show, setShow] = useToggle(false);
  const [idxaddress, setidxAddress] = useState([]);
  const [newoffer, setNewOffer] = useState({
    propertytype: "",
    state: "",
    propertyaddress: "",
    listing_id: "",
    offercode: "",
    clienttype: "",
    clientid: "",
    clientname: "",
    buyertype: "VABuyer",
    agent: { id: "", name: "" },
    coagent: { id: "", name: "" },
    externalagent: { id: "", name: "" },
    buyer_type:""
    
  });
  const [error, setError] = useState<NewOffervalidation>({
    propertytype: "",
    state: "",
    propertyaddress: "",
    listing_id: "",
    offercode: "",
    clienttype: "",
    clientid: "",
    clientname: "",
    buyertype: "",
    agent: "",
    coagent: "",
    externalagent: "",
  });
  const [contactlist, setContactList] = useState<contactlist[]>([]);
  const [showSuggestions, setShowSuggestions] = useState<showsuggestions>({
    contact: false,
    agent: false,
    coagent: false,
    address: false,
    externalagent: false,
  });
  const [filteredcontactlist, setfilteredContactList] = useState<contactlist[]>(
    []
  );
  const [filteredaddress, setfilteredAddress] = useState<filteredadress[]>([]);
  const [coagent, setCoAgent] = useState<roleslist>({
    agents: [],
    coagents: [],
    externalagents: [],
  });
  const [listingsuggestions, setlistingSuggestions] = useState<roleslist>({
    agents: [],
    coagents: [],
    externalagents: [],
  });
  const history = useHistory();

  let prev = history.location.pathname.split("/").filter((v) => v);
  let currentpath = prev.length >= 1 ? prev[0] : null;

  const SidebarItem = (p: CSidebarNavItem) => {
    return (
      <CSidebarNavItem
        onClick={() => {
          props.dispatch(setLeadSearchCriteria(defaultLeadSearchCriteria));
          props.dispatch(setLeadPaginator(defaultPaginator));
          props.dispatch(setUsersPaginator(defaulSortedtPaginator));
          props.toggleSidebarMobile(false);
        }}
        {...p}
      />
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      let localValue = localStorage.getItem("loading");
      if (localValue === "true") {
        setLoading(false); // Stop the loading
        clearInterval(interval); // Stop the interval
      }
    }, 1000); // Run every second

    return () => {
      clearInterval(interval); // Clean up the interval on component unmount
    };
  }, []);

  const handleToggleSidebar = () => {
    props.toggleSidebarMobile(!props.showSidebar);
  };

  return (
    <>
      <CSidebar
        colorScheme={"dark"}
        unfoldable={false}
        minimize={false}
        show={props.showSidebar}
        onShowChange={props.toggleSidebarMobile}
      >
        <div onClick={() => handleToggleSidebar()}>
          <span className="c-header-toggler-icon sidebar-close">
            <Icon kind={ICON_KIND.Down} />
          </span>
        </div>

        <CSidebarBrand className="d-md-down-none p-3" to="/">
          <CImg
            src="/images/logo.png"
            height={64}
            className="c-sidebar-brand-full img-fluid"
          />
          <CImg
            src="/images/logo-mark.png"
            height={48}
            className="c-sidebar-brand-minimized"
          />
        </CSidebarBrand>
        <div
          className="d-flex flex-column jutsify-content-between h-100"
          onClick={() => handleToggleSidebar()}
        >
          <CSidebarNav>
            {loading === true ? (
              <Skeleton count={18} height={25} className={"shimmerTable"} />
            ) : (
              <CCreateElement
                items={getNavigation()}
                components={{
                  CSidebarNavDivider,
                  CSidebarNavDropdown,
                  CSidebarNavItem,
                  CSidebarNavTitle,
                  SidebarItem,
                }}
              />
            )}
          </CSidebarNav>
          <>
            {/* <TransactionSidebar
              currentpath={currentpath}
              modalshow={modalshow}
              toggle={toggle}
              show={show}
              setShow={setShow}
              newoffer={newoffer}
              setNewOffer={setNewOffer}
              contactlist={contactlist}
              setContactList={setContactList}
              showSuggestions={showSuggestions}
              setShowSuggestions={setShowSuggestions}
              filteredcontactlist={filteredcontactlist}
              setfilteredContactList={setfilteredContactList}
              coagent={coagent}
              setCoAgent={setCoAgent}
              idxaddress={idxaddress}
              setidxAddress={setidxAddress}
              filteredaddress={filteredaddress}
              setfilteredAddress={setfilteredAddress}
              listingsuggestions={listingsuggestions}
              setlistingSuggestions={setlistingSuggestions}
              error={error}
              setError={setError}
            /> */}

            <div className="p-2 pb-4 d-flex align-items-center justify-content-center">
              <CNavLink to="/change-log">
                <CIcon className="mr-2" content={cilBullhorn} /> What's New
              </CNavLink>
            </div>
          </>
        </div>
      </CSidebar>
    </>
  );
};

export default connect((state: State) => ({
  user: state.auth.user,
  leads: state.leads.lead,
}))(TheSidebar);
